const AUTH_TEST_ENV_URL = 'https://multiregion-retail-launchpad-athlete-token.rbh-retail-launchpad-test.nikecloud.com/store/athlete_jwts/v1';
const AUTH_PROD_ENV_URL = 'https://multiregion-retail-launchpad-athlete-token.rbh-retail-launchpad-prod.nikecloud.com/store/athlete_jwts/v1';

export const GET_ATHLETE_AUTH_URL = (env) => {
    if (env === 'prod') {
        return AUTH_PROD_ENV_URL;
    }
    return AUTH_TEST_ENV_URL;
}
